// libs
import React, { memo } from 'react';

// styles
import {
  Container,
  Images,
  Thumbnails,
  Thumbs,
  MainImage,
  Details,
  Title,
  SubTitle,
  Price,
  ShimmerLine,
  Button,
} from './styles';

// constants
import { BUTTON_TEXT } from './constants';

function Placeholder() {
  return (
    <Container>
      <Images>
        <Thumbnails>
          <Thumbs />
          <Thumbs />
          <Thumbs />
          <Thumbs />
        </Thumbnails>
        <MainImage />
      </Images>
      <Details>
        <Title />
        <SubTitle />
        <Price />

        <ShimmerLine />
        <ShimmerLine />
        <SubTitle />

        <Button>{BUTTON_TEXT}</Button>
      </Details>
    </Container>
  );
}

export default memo(Placeholder);
